import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { OsnovZaPravoNaGo } from './osnov-za-pravo-na-go';
import { Component } from "@angular/core";
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'yt-osnov-za-pravo-na-go-modal-update',
    templateUrl: './osnov-za-pravo-na-go-modal-update.component.html'
})
export class OsnovZaPravoNaGoModalUpdateComponent extends BaseModalUpdateComponent<OsnovZaPravoNaGo>{
    constructor(
        protected modalContainerService: ModalContainerService<OsnovZaPravoNaGo>,
        protected activeModal: NgbActiveModal,
        protected modalService: ModalService
    
      ) { 
        super(modalContainerService, activeModal,modalService);
      }
    
}
